import * as Yup from "yup";

export default Yup.object().shape({
    name: Yup.string()
        .required("Please enter a product name"),
    price: Yup.number("Please enter number")
        .nullable().required("Please enter price"),
});